export const REWARD_FLIGHT_MS = 900;
const REWARD_SETTLE_MS = 450;

const amount = (value) =>
  Number.isFinite(value) ? Math.max(0, Math.floor(value)) : 0;

export const getCollectionRewards = (result) => ({
  shards: amount(result?.earned ?? result?.loot?.shards),
  healed: amount(
    (result?.healed ?? result?.loot?.heal ?? 0) -
      amount(result?.healedOnLanding)
  ),
  maxHp: amount((result?.maxHpGained ?? 0) - amount(result?.maxHpOnLanding)),
});

// Small rewards get one pickup per point. Large rewards use labeled bundles
// so a powerful build never creates hundreds of DOM nodes or a long wait.
const bundles = (total, limit, kind) => {
  const count = Math.min(total, limit);
  return Array.from({ length: count }, (_, index) => ({
    id: `${kind}:${index}`,
    kind,
    amount:
      Math.floor(((index + 1) * total) / count) -
      Math.floor((index * total) / count),
  }));
};

export const getRewardPickups = (result) => {
  const rewards = getCollectionRewards(result);
  const shards = bundles(rewards.shards, 24, 'shards');
  const potions = bundles(rewards.healed, 12, 'health');
  const pickups = [];
  for (
    let index = 0;
    index < Math.max(shards.length, potions.length);
    index++
  ) {
    if (shards[index]) pickups.push(shards[index]);
    if (potions[index]) pickups.push(potions[index]);
  }
  const stagger = Math.min(110, 1000 / Math.max(1, pickups.length - 1));
  return pickups.map((pickup, index) => ({
    ...pickup,
    delay: index * stagger,
  }));
};

export const getRewardCollectionDuration = (result, reduceMotion = false) => {
  const pickups = getRewardPickups(result);
  if (!pickups.length) return 0;
  return reduceMotion
    ? 200
    : REWARD_FLIGHT_MS + pickups[pickups.length - 1].delay + REWARD_SETTLE_MS;
};

export const getRewardDisplay = (game, result, progress) => {
  if (!result) return null;
  const rewards = getCollectionRewards(result);
  const collected = progress?.result === result ? progress : {};
  const healed = Math.min(rewards.healed, collected.healed || 0);
  const maxHp = Math.max(10, game.maxHp || 0, game.hp);
  return {
    ...collected,
    shards: game.shards - rewards.shards + (collected.shards || 0),
    hp: Math.max(0, game.hp - rewards.healed + healed),
    maxHp:
      maxHp -
      rewards.maxHp +
      (rewards.healed > 0
        ? Math.round((rewards.maxHp * healed) / rewards.healed)
        : rewards.maxHp),
  };
};
